import * as types from "./mutation-types"
import { addOrUpdateItem } from "./helpers"

export default {
    [types.ADD_OR_UPDATE_PROPOSAL_STATS]: (state, item) => addOrUpdateItem(state, item, 'id', 'proposalStats'),

    [types.ADD_OR_UPDATE_APPLICATION_UNDER_REVIEW]: (state, item) => addOrUpdateItem(state, item, 'id', 'applicationsUnderReview'),

    [types.ADD_OR_UPDATE_APPLICATION_SIGNED_OFF]: (state, item) => addOrUpdateItem(state, item, 'id', 'applicationsSignedOff')
}
